export default __webpack_public_path__ + "static/media/anykeyHover.15b028fe.png";